<div class="referral-dialog-container redesigned-referral-dialog">
  <div class="d-flex align-items-center justify-content-center dialog-header">
    <mat-icon class="dialog-header-icon">assignment_turned_in</mat-icon>
    <h2 class="dialog-title small-title">Manage Referral Classifications</h2>
    <mat-icon
      matTooltip="Select the issues you would like to include in the referral letter. If no issues are selected, a general referral letter will be generated."
      matTooltipPosition="right" matTooltipClass="multiline-tooltip" class="ml-2 cursor-pointer mat-info-icon">
      help
    </mat-icon>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Classifications List (with static 'Generic' option) -->
    <!-- <div class="section-title mb-2">Classifications</div> -->
    <div class="px-2">
      <div class="list-group list-group-flush">
        <ng-container *ngIf="isLoading; else classificationList">
          <div *ngFor="let item of [1,2,3,4,5]" class="classification-card">
            <div class="border-bottom p-2 bg-white small-font">
              <div class="d-flex align-items-start gap-2">

                <!-- Checkbox skeleton -->
                <div class="skeleton-checkbox"></div>

                <div class="flex-grow-1">
                  <div class="d-flex align-items-center">

                    <!-- Code badge skeleton -->
                    <div class="skeleton-badge"></div>

                    <!-- Text skeleton -->
                    <div class="skeleton-text ml-2"></div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </ng-container>
        <!-- Dynamic Classifications -->
        <ng-template #classificationList>
          @if(classifications.length){
          <div *ngFor="let classification of classifications" class="classification-card"
            [class.classification-selected]="classification.selected">
            <div class="classification-row border-bottom p-2 bg-white small-font">
              <div class="d-flex align-items-start gap-2">
                <input type="checkbox" class="cursor-pointer form-check-input mt-1" [checked]="classification.selected"
                  (change)="toggleClassification(classification)" style="accent-color: #1976d2;" />
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center">
                    <span class="code-badge badge bg-custom-gray text-black border fw-medium small-font">
                      {{ classification.code }}
                    </span>
                    <p class="classification-name mb-0 text-black lh-sm ml-2">{{ classification.display }}</p>
                  </div>
                  <!-- <div class="small mt-2">
                  <p class="mb-0 text-black lh-sm ml-2">{{ classification.display }}</p>
                </div> -->
                </div>
              </div>
            </div>
          </div>
          }@else{
          <p>There are currently zero classifications available, please proceed with letter/note generation.</p>
          }
        </ng-template>
      </div>
    </div>

    <!-- End of scrollable content -->
  </mat-dialog-content>

  <!-- Sticky Past History as Classification -->
  <div class="sticky-past-history border-top">
    <label class="history-option p-2 bg-white small-font d-flex justify-content-end gap-2"
      [class.patient-history-disabled]="isPatientHistoryDisabled">
      <input type="checkbox" class="form-check-input mt-1"
        [class.cursor-pointer]="!isPatientHistoryDisabled"
        [(ngModel)]="includepatientHistory"
        [disabled]="isPatientHistoryDisabled"
        style="accent-color: #1976d2;" />
      <span class="text-black fw-medium small-font">
        Include Patient History
      </span>
      <mat-icon [matTooltip]="patientHistoryTooltip"
        matTooltipPosition="right" class="cursor-pointer mat-info-icon">
        info
      </mat-icon>
    </label>
  </div>

  <mat-dialog-actions class="dialog-actions fixed-width-actions">
    <button mat-raised-button class="cancel-btn small-font fixed-width-btn" (click)="onCancel()">
      Cancel
    </button>
    <button mat-raised-button class="proceed-btn small-font fixed-width-btn" (click)="onProceed()">
      Proceed
    </button>
  </mat-dialog-actions>
</div>
